// extracted by mini-css-extract-plugin
module.exports = {"loginForm":"LoginOrSignupModal_loginForm__VgNWt"};